namespace Matrix.Common {
    export interface UserPreferenceUpdateRequest extends Serenity.ServiceRequest {
        PreferenceTypeCode?: string;
        PreferenceName?: string;
        Value?: string;
    }
}
